// @flow
import React from 'react'
import { Dock } from 'react-dock'
import { Menu, Button, Icon } from 'semantic-ui-react'
import { Link } from 'react-scroll'
import renderHTML from 'react-render-html'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import './styles.scss'

const scrollSpeed = 5
const scrollOffset = -40
export class TopMenu extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      activeItem: null
    }
    this.handleClick = this.handleClick.bind(this)
    this.handleSetActive = this.handleSetActive.bind(this)
    this.calculateScrollDuration = this.calculateScrollDuration.bind(this)
  }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  setMenuPosition() {
    const targetEl = document.getElementById('nav-' + this.state.activeItem)
    console.log('set menu pos to:', targetEl)
    document.getElementById('top-menu').parentNode.scrollTop =
      targetEl.offsetTop - 150
  }

  handleSetActive(to) {
    // console.log('handleSetActive:', to)
    // localStorage.setItem('actvChptr', to)
    this.setState({ activeItem: to })
  }

  handleClick() {
    // console.log('handleClick')
    if (browserCheck.isMobile) {
      this.props.closeMenu()
    }
  }

  calculateScrollDuration(targetElement) {
    // console.log('calculateScrollDuration')
    // console.log('targetElement: ', targetElement)

    // track in google analytics
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: `side-menu: ` + targetElement
    })

    const scrollTarget = document.getElementById(targetElement)
    const rect = scrollTarget.getBoundingClientRect()
    const parentRect = document.documentElement.getBoundingClientRect()
    const scrollY = document.documentElement.scrollTop
    const targetY = rect.top - parentRect.top
    const scrollDistance =
      targetY >= scrollY
        ? targetY - scrollY + scrollOffset
        : scrollY - targetY - scrollOffset
    const scrollDuration = scrollDistance / scrollSpeed
    /*
    console.log('scrollY:', scrollY)
    console.log('targetY:', targetY)
    console.log('scrollOffset:', scrollOffset)
    console.log('scrollDistance:', scrollDistance)
    console.log('scrollDuration:', scrollDuration)
    */
    return scrollDuration > 750
      ? scrollDuration < 3000
        ? scrollDuration
        : 3000 // max duration = 3000
      : 750 // min duration = 500
  }

  render() {
    // console.log('render')
    const output = this.props.menuData.map(
      function(chapter, i) {
        let subOutput = null
        if (chapter.subchapters) {
          subOutput = chapter.subchapters.map(
            function(subchapter, ii) {
              return (
                <Link
                  id={'nav-' + i + '-' + ii}
                  activeClass='active'
                  className='sub nav-link'
                  to={'person-' + i + '-' + ii}
                  spy
                  smooth
                  duration={function(scrollDistanceInPx) {
                    const duration = this.calculateScrollDuration(
                      'perons-' + i + '-' + ii
                    )
                    // console.log('duration:', duration)
                    return duration
                  }.bind(this)}
                  offset={scrollOffset}
                  isDynamic
                  onSetActive={this.handleSetActive}
                  onClick={this.handleClick}
                  smooth='easeInOutCirc'
                >
                  <Menu.Item name={subchapter}>
                    <div className='item-wrapper'>
                      <div className='icn'>
                        <Icon name='angle right' />
                      </div>
                      <div className='subtxt'>{renderHTML(subchapter)}</div>
                    </div>
                  </Menu.Item>
                </Link>
              )
            }.bind(this)
          )
        }

        return (
          <>
            <Link
              id={'nav-' + i}
              activeClass='active'
              className='nav-link'
              to={'person-' + i}
              spy
              smooth
              duration={function(scrollDistanceInPx) {
                const duration = this.calculateScrollDuration('person-' + i)
                // console.log('duration:', duration)
                return duration
              }.bind(this)}
              offset={scrollOffset}
              isDynamic
              onSetActive={this.handleSetActive}
              onClick={this.handleClick}
              smooth='easeInOutCirc'
            >
              <Menu.Item name={chapter.title}>
                {renderHTML(
                  chapter.subtitle +
                    '<br /><span className="names">' +
                    chapter.title +
                    '</span>'
                )}
              </Menu.Item>
            </Link>
            {subOutput || null}
          </>
        )
      }.bind(this)
    )

    return (
      <div>
        <Dock
          position='right'
          size={
            browserCheck.isDesktop ? 0.3 : browserCheck.isTablet ? 0.6 : 0.9
          }
          dimMode='none'
          isVisible={this.props.menuOpen}
        >
          <div
            onClick={this.props.closeMenu}
            id='top-menu'
            className='top-menu'
          >
            <Menu className='vertical'>
              {output}
              <div className='button-wrapper'>
                <Button
                  onClick={this.props.closeMenu}
                  attched='right'
                  className='closer'
                >
                  <Icon name='times large circle' />
                </Button>
              </div>
            </Menu>
          </div>
        </Dock>
      </div>
    )
  }
}
